import React from "react";

import ScaleLoader from "react-spinners/ScaleLoader";

const LoadingIndicator = ({ message }) => {
  return (
    <div className="loading flex p-16 flex-wrap justify-center items-center">
      <ScaleLoader size={200} color="#35AF2E" loading={true} />
      <div className="w-full text-center font-bold text-xl text-gray-700 mt-4">
        {message ? message : "Cargando datos del servidor"}
      </div>
    </div>
  );
};

export default LoadingIndicator;
